import type { ReactElement } from "react";

import { useSelector } from "react-redux";

import {
    ColumnsSelectionModal,
    type SelectionModalProps,
} from "app/pages/sales-intelligence/common-components/column-picker";
import { selectActiveLeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import { useLeadsColumnSelectionPlugins } from "app/pages/sales-intelligence/modules/leads-search/hooks/useLeadsColumnSelectionPlugins";
import { useColumnSelectionMutation } from "app/pages/sales-intelligence/modules/lists/query/queries/useColumnSelectionMutation";

import { useListsColumnsConfig } from "../../../hooks/useListsColumnsConfig";
import { useListsColumnSelectionOptions } from "../../../hooks/useListsColumnSelectionOptions";

import { SELECTION_MODAL_TITLE } from "./const";

const SelectionModalContainer = ({ isOpen, closeModal }: SelectionModalProps): ReactElement => {
    const activeLeadsType = useSelector(selectActiveLeadsType);

    const columnsConfig = useListsColumnsConfig(activeLeadsType);

    const { selectedColumnIds, categories, availableColumns } = useListsColumnSelectionOptions(
        columnsConfig,
        activeLeadsType,
    );
    const { config, pluginCleanup } = useLeadsColumnSelectionPlugins();

    const handleCloseModal = () => {
        closeModal();
        pluginCleanup();
    };

    const { mutateAsync, isPending } = useColumnSelectionMutation();

    const handleApply = async (columns: readonly string[]): Promise<void> => {
        await mutateAsync({ columns });
        handleCloseModal();
    };

    return (
        <ColumnsSelectionModal
            isOpened={isOpen}
            isApplyPending={isPending}
            title={SELECTION_MODAL_TITLE}
            initialSelectedColumnIds={selectedColumnIds}
            columnOptions={availableColumns}
            categoryConfig={categories}
            pluginConfig={config}
            onApply={handleApply}
            onCancel={handleCloseModal}
        />
    );
};

export default SelectionModalContainer;
